import React from 'react';
import { GetServerSideProps } from 'next';
import IncomingMessageWithCookies from 'types/IncomingMessageWithCookies';

import { useForceUpdateOnWindowResize } from '@zola/zola-ui/src/hooks/useForceUpdateOnWindowResize';
import { UserContext } from '@zola-helpers/client/dist/es/@types';

// Zola UI Components
import { PreauthFooterV3 } from '@zola/zola-ui/src/components/PreAuthV3';

// Utils
import { fetchNavHTML } from 'libs/server/nav';
import { fetchUser } from 'libs/server/users';
import { useIsPostAuthNav3MobileOrDesktop } from 'hooks/useIsPostAuthNav3Active';

// Components
import Nav from 'components/Nav';
import Header from 'components/LP/ContactUs/Header';
import { PageWrapper } from 'components/LP/v3/PageWrapper.styles';
import Hero from 'components/LP/ContactUs/Hero';
import ContactSection from 'components/LP/ContactUs/ContactSection';
import PartnerSection from 'components/LP/ContactUs/PartnerSection';
import AnswersSection from 'components/LP/ContactUs/AnswersSection';

// Constants
import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';

export type ContactUsLPProps = {
  navHTML: string | null;
  userCtx: UserContext | null;
};

const ContactUsLP: React.FC<ContactUsLPProps> = ({ navHTML, userCtx }): JSX.Element | null => {
  const isPostAuthNav3Enabled = useIsPostAuthNav3MobileOrDesktop(userCtx);

  useForceUpdateOnWindowResize();

  return (
    <>
      <Header />
      <Nav
        {...(isPostAuthNav3Enabled && { activePrimaryLink: PrimaryNavIdentifier.HELP })}
        navHTML={navHTML}
        user={userCtx}
        disablePrimaryNavCollapse
        disableSecondary
      />
      <PageWrapper isPostAuthNav3={isPostAuthNav3Enabled}>
        <Hero />
        <AnswersSection />
        <ContactSection />
        <PartnerSection />
        <PreauthFooterV3 isGuest={userCtx ? Boolean(userCtx.is_guest) : true} />
      </PageWrapper>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<ContactUsLPProps> = async ({
  req,
}: {
  req: IncomingMessageWithCookies;
}) => {
  const [navHTML, userCtx] = await Promise.all([fetchNavHTML(req), fetchUser(req)]);

  return {
    props: {
      navHTML,
      userCtx,
    },
  };
};

export default ContactUsLP;
